import { BaselineDto } from "@shared/types/baselines/baselines.dto";

/**
 * Sort by draft grade, filter by sign relative to neutral, then sort for display.
 */
export function filterAndSortBaselines(
  baselines: BaselineDto[],
  viewMode: "positive" | "negative",
  neutralGrade = 0,
): BaselineDto[] {
  const sorted = [...baselines].sort((a, b) => a.draftGrade - b.draftGrade);
  return sorted
    .filter((b) =>
      viewMode === "positive"
        ? b.draftGrade >= neutralGrade
        : b.draftGrade < neutralGrade,
    )
    .sort((a, b) =>
      viewMode === "positive"
        ? a.draftGrade - b.draftGrade
        : b.draftGrade - a.draftGrade,
    );
}
